import enumeration from "./enumeration";

const TransactionStatus = {
  SUCCESS: "SUCCESS",
  VOID: "VOID",
  EDITED: "EDITED",
};

export default enumeration(TransactionStatus);
